// extracted by mini-css-extract-plugin
export default {"card_error__wrapper":"download_card_error__wrapper__7b1Kd"};